export const locale = {
  dashboard_origin: "仪表板",
  menu: "菜单",
  get_menu_again: "重新获取菜单",
  loading_error: {
    title: "加载错误！",
    message: "加载数据时出错！请重试",
    text: "重试",
  },
  copy_right: {
    year: "1404",
    text1: "本系统所有物质和精神权利受保护，属于广告公司",
    text2: "最佳企业家",
    text3: "Sehr Arad，任何复制将受到法律追究。",
  },
  user: "尊贵的用户",
  hi: "你好",
  exit: "退出",
  go_to_page: "前往页面",
  show: "显示",
  until: "至",
  from: "从",
  page: "页",
  notes: "笔记",
  created_at: "创建日期",
  registration: "注册",
  edit_contact: "编辑联系人",
  cancel: "取消",
  edit: "编辑",
  delete: "删除",
  contact_info: "联系信息",
  add_birthday: "添加生日",
  contacts: "电话簿",
  last_updated_at: "最后更新",
  added_to_contact: "已添加到联系人",
  contact_registered: "您的联系人未保存。",
  transaction: "交易",
  write_message: "写消息",
  note_title: "笔记标题",
  create_note: "添加笔记",
  are_you_sure_to_delete: "您确定要删除吗？",
  last_transaction: "最近交易",
  your_balance: "您的余额",
  no_transaction: "您还没有交易记录！",
  increase_balance: "增加余额",
  transaction_list: "交易列表",
  withdraw: "提现",
  decrease: "提现",
  deposit: "存款",
  increase: "存款",
  charge: "钱包充值",
  refund: "退款",
  save: "保存",
  reload: "刷新列表",
  shared: "共享",
  list: "列表",
  single_add: "单个添加",
  mass_add: "批量添加",
  excel_add: "Excel 添加",
  added_successfully: "添加成功",
  error_add_phone: "添加号码时出错",
  group: {
    add: "添加新组",
    delete: "删除组",
    edit: "编辑组",
    first: "先添加一个新组。",
  },
  successfully_deleted: "删除成功",
  notification: {
    text: "用户通知",
    new: "新消息",
    messages: "消息",
    events: "事件",
    no_new_message: "没有新消息！",
    show_all: "显示全部",
    no_new_event: "没有新事件！",
    go_to_user: "前往用户",
    watched: "已查看",
  },
  locking_for_service: "您在寻找哪项服务？",
  service_name: "输入您想要的服务名称...",
  invite: {
    title: "向朋友介绍系统。",
    gift: "礼物",
    get: "领取。",
    phone: "输入号码。",
    invite: "邀请！",
    got_it: "明白了",
    get_gift: "领取礼物",
    success: "您的邀请消息已成功发送。",
    wrong_number: "请输入正确号码。",
  },
  ticker: {
    text: "我们随时为您服务...",
    help: "注册票据以联系支持团队",
    register: "注册票据",
  },
  package: {
    title: "活跃套餐",
    no: "您没有活跃套餐。",
    no_limit: "无限面板",
    day: " 天",
    other: " 其他",
    expiration: "结束 ",
    expired: "已过期 ",
  },
  Loading: {
    Waiting: "请稍等",
    Description: "等待几秒钟",
  },
  Questions: {
    Yes: "是",
    No: "否",
  },
  Success: {
    Title: "成功",
    defaultActionText: "明白了",
  },
  Info: {
    Title: "信息",
    defaultActionText: "明白了",
  },
  Warning: {
    Title: "注意",
    defaultActionText: "明白了",
  },
  Error: {
    Title: "错误",
    defaultActionText: "明白了",
  },
  Wallet: {
    Title: "余额不足",
    defaultActionText: "明白了",
  },
  ConnectionLost: {
    Title: "互联网连接中断",
    Subtitle: "请检查您的互联网连接",
    Button: "重试",
  },
  emoji: "表情符号",
  text_suggest_free: "文本顾问（免费）",
  select_campaign: "选择活动",
  short_link: "短链接",
  text_suggest: "文本顾问",
  select_emoji: "选择表情符号",
  default_text: "默认文本",
  emoji_group: {
    "Smileys & Emotion": "表情与情感",
    "People & Body": "人物与身体",
    "Animals & Nature": "动物与自然",
    "Food & Drink": "食物与饮料",
    "Travel & Places": "旅行与地点",
    Activities: "活动",
    Objects: "物体",
    Symbols: "符号",
    Flags: "旗帜",
  },
  table: {
    index: "序号",
    title: "标题",
    text: "文本",
    select: "选择",
    next: "下一页",
    previous: "上一页",
    rows_per_page: "每页行数",
    no_data: "无数据显示",
    search_placeholder: "搜索",
  },
  modal: {
    success: "成功",
  },
  actions: {
    remove: "移除",
    copyLink: "复制链接",
    operations: "操作",
    edit: "编辑",
    delete: "删除",
    show: "显示",
    accept: "确认",
    reject: "拒绝",
    enable: "启用",
    download: "下载",
    deactive: "禁用",
  },

  shortLink: {
    freeShorten: "免费缩短您的链接。",
    clickToSelect: "点击您想要的链接进行选择。",
    create: "创建短链接",
    title: "标题",
    titleHint: "为短链接添加名称。",
    link: "链接",
    linkHint: "输入您想要的链接。",
    shortenedLink: "缩短链接",
    clickCount: "点击次数",
    selectDomain: "选择域名",
  },
  pagination: {
    next: "下一页",
    previous: "上一页",
    rowsPerPage: "每页行数",
    noData: "无数据显示",
    search: "搜索",
  },
  validation: {
    titleRequired: "标题必填",
    minLength4: "至少 4 个字符",
    linkRequired: "链接必填",
    mustIncludeHttps: "必须包含 https://",
    invalidLink: "请输入正确链接。",
  },
  messages: {
    addedSuccessfully: "添加成功。",
    confirmDeleteShortLink: "确认删除短链接？",
  },
  inputMenu: {
    text: "文本",
    selectUserInfo: "选择用户信息",
  },
  patternDialog: {
    title: "选择模板/活动",
    change: "更改模板/活动",
    createPattern: "保存新模板",
    createCampaign: "保存新活动",
    tabs: {
      pattern: "选择模板",
      campaign: "选择活动",
    },
    empty: "未找到模板，请先保存一个模板。",
    columns: {
      id: "ID",
      type: "类型",
      pattern: "模板",
      static: "固定",
      title: "标题",
      content: "文本",
      status: "状态",
      rejected: "已拒绝",
      approved: "已批准",
    },
    pagination: {
      next: "下一页",
      prev: "上一页",
      rowsPerPage: "每页行数",
      noData: "无数据显示",
      search: "搜索",
    },
  },
  PATTERN: {
    SELECTED_MESSAGE: "选定消息：",
    REQUIRED_INPUTS: "必填字段：",
    SELECTED_CAMPAIGN: "选定活动：",
    CAMPAIGN_ID: "ID",
    PRE_NAME: "前缀名",
    NAME: "姓名",
    MIDDLE_NAME: "中间名",
    LAST_NAME: "姓氏",
    POST_NAME: "后缀名",
    ALIAS: "别名",
    COMPANY: "公司",
    JOB_TITLE: "职位",
    PHONE: "电话",
    BIRTHDAY: "生日",
    DESCRIPTION: "描述",
  },
  CONTACT_GROUP: {
    LIST: "列表",
    ADD: "添加",
    SEARCH: "搜索",
    INDEX: "序号",
    ID: "ID",
    GROUP_NAME: "组名",
    PARENT: "上级",
    CREATE: {
      GROUP_NAME: "默认组名",
      PARENT_CATEGORY: "上级类别",
      ADD_GROUP: "添加组",
      SUCCESS: "默认组添加成功。",
      ERROR: "添加默认组时出错！",
      SEARCH: "搜索",
      TITLE: "标题",
      SEARCH_IN_TITLE: "在标题中搜索",
      FROM: "从",
      TO: "至",
      BIRTHDAY_FROM: "生日从",
      BIRTHDAY_TO: "至",
      ITEMS_PER_PAGE: "每页项目数",
      PHONE_COPY: "复制号码",
      COPY_PHONE: "复制号码",
      DELETE_CONTACT_GROUP: "从组中删除联系人",
      DELETE_FROM_GROUP_ONLY: "仅从此组删除联系人",
      DELETE_FROM_ALL_GROUPS: "从所有组删除联系人",
      USER: "用户",
      PHOTO: "照片",
      FULL_NAME: "姓名",
      EMAIL: "电子邮件",
      PHONE_NUMBER: "电话号码",
      JOB_TITLE_COMPANY: "职位和公司",
      CREATED_AT: "创建时间",
      PHONEBOOK: "电话簿",
      ACTIONS: "操作",
    },
    TITLE: "标题",
    SEARCH_IN_TITLE: "在标题中搜索",
    FROM: "从",
    TO: "至",
    BIRTHDAY_FROM: "生日从",
    BIRTHDAY_TO: "至",
    ITEMS_PER_PAGE: "每页项目数",
    PHONE_COPY: "复制号码",
    COPY_PHONE: "复制号码",
    DELETE_CONTACT_GROUP: "从组中删除联系人",
    DELETE_FROM_GROUP_ONLY: "仅从此组删除联系人",
    DELETE_FROM_ALL_GROUPS: "从所有组删除联系人",
    USER: "用户",
    PHOTO: "照片",
    FULL_NAME: "姓名",
    EMAIL: "电子邮件",
    PHONE_NUMBER: "电话号码",
    JOB_TITLE_COMPANY: "职位和公司",
    CREATED_AT: "创建时间",
    PHONEBOOK: "电话簿",
    ACTIONS: "操作",
  },
  GRADUAL: {
    SEND_GRADUAL: "分阶段发送",
    ALLOWED_HINT: "适用于超过 500 个号码",
    SEND_GRADUAL_OPTION: "分阶段发送",
    AFTER_EVERY: "每",
    SEND_SMS: "条短信发送？",
    TIME_INTERVAL: "时间间隔",
    SMS_PART: "短信数量",
    SMS_PART_HINT: "输入每批发送的短信数量。",
    COUNT_ERROR: "每批短信数量不能少于 500！",
  },
  HISTORY: {
    CREATE_NEW: "创建新历史",
    BACK: "返回",
    TITLE: "历史标题",
    STEP: "步骤",
    LAST_CALL: "上次通话时间",
    DISCUSSIONS: "进行的讨论",
    REMIND_DATE: "提醒时间",
    FOLLOWUP: "下次通话跟进事项",
    SAVE_HISTORY: "保存历史",
    INDEX: "序号",
    SAVED_BY: "保存者",
    ACTION: "管理",
    MORE_INFO: "更多信息",
    CREATE_ERROR: "添加客户历史时出错！",
  },
  FORMS: {
    SourceNumber: "源号码",
    DestinationPhone: "目标号码",
    Add: "添加",
    SEND_TO_SELECTED_NUMBERS: "发送到选定号码",
    CHANGE_PATTERN_CAMPAIGN: "更改模板/活动",
    SendTime: "发送时间",
    SELECTED_MESSAGE: "选定消息",
    REQUIRED_INPUTS: "必填字段",
    SELECTED: "已选择",
    ID: "ID",
    SEND: "发送",
    DATE_REQUIRED: "必须选择日期。",
    TIME_INTERVAL: "时间间隔",
    TIME_INTERVAL_FROM_PREVIOUS: "与上一条消息的时间间隔",
    Title: "标题",
    LINK: "链接",
    LINK_HINT: "任意",
    LINK_PLACEHOLDER: "示例[](https://example.ex/any)",
    LINK_SHORTENED_HINT:
      "您的链接缩短后将以 14 个字符显示（example.ex/any），每条消息将发送唯一链接。",
    Text: "文本",
    MUST_INCLUDE_PATTERN: "必须包含 {pattern} 表达式",
    INVALID_LINK: "请输入正确链接",
  },
  ERRORS: {
    VpnDetectedTitle: "请关闭 VPN",
    VpnDetectedSubtitle: "这将使系统运行更好，让您有更好的体验。",
    PhoneIsNotValid: "电话号码无效",
    MaxPhoneLimit: "无法添加超过 50,000 个号码。",
    NoSelectedLineNumber: "未选择源号码。",
    INVALID_TIMER: "请输入正确时间",
    NoAccess: "您没有权限",
    PleaseBuyAPlane: "请购买一个套餐",
    NoAccountCharge: "账户余额不足",
    PleaseChargeYourAccount: "请充值您的账户",
    Unauthorized: "无权限：请重新登录",
    ServerError: "服务器错误，请稍后重试",
    NetworkError: "网络错误：请检查您的互联网连接",
    InvalidInput: "无效输入",
    SessionExpired: "会话已过期，请重新登录",
    TokenInvalid: "无效令牌",
    VpnDetected: "您的 VPN 已开启，请关闭",
    RequestTimeout: "请求超时，请重试",
    DuplicateEntry: "此项已注册",
  },

  BUTTONS: {
    DELETE_NUMBERS: "删除号码",
    ADD_BULK: "批量添加",
    FROM_FILE: "从文件",
    More: "更多",
    BuyAPlane: "购买套餐",
    AccountCharge: "账户充值",
    OK: "确定",
    Close: "关闭",
    Cancel: "取消",
    Retry: "重试",
    Login: "登录",
    Logout: "退出",
    Save: "保存",
    Submit: "提交",
  },
  GENERAL: {
    row: "序号",
    id: "ID",
    back: "返回",
    manage: "管理",
    SENDING: "发送中",
    RELOAD: "刷新",
    PRINT: "打印",
    DELETE: "删除",
    SUBMIT: "提交",
    SUCCESSFULLY_ADDED: "添加成功",
    RELOAD: "刷新",
    CANCEL: "取消",
    SUCCESSFULLY_DOWNLOADED: "下载成功",
    Loading: "加载中...",
    NoData: "未找到数据",
    Welcome: "欢迎",
    Profile: "个人资料",
    Settings: "设置",
    Wallet: "钱包",
    Dashboard: "仪表板",
  },

  NOTICES: {
    Attention: "注意",
    MinimumSendWarning:
      '"新闻发送" 使用源号码发送时，最小数量必须为 {{number}}。',
  },
  contactsTags: {
    select_group: "选择组",
    create_group: "创建组",
    search: "搜索",
    add_group: "添加组",
    enter_group_name: "输入您想要的名称",
    group_name: "组名",
    cancel: "取消",
    edit: "编辑",
    save: "保存",
    loading_categories: "加载类别中...",
    select_group_and_subgroup: "选择组和子组",
    add_group_with_subgroups: "添加组及子组",
    add_group_only: "仅添加选定组",
    duplicate_name_error: "名称已存在",
    added_successfully: "添加成功。",
    confirm_delete_group: "确认删除组？",
    deleted_successfully: "删除成功",
    edited_successfully: "编辑成功",
    group_added_successfully: "选定组已成功添加。",
    error_creating_group: "添加默认组时出错",
    create_default_group: "创建默认组",
    select_default_group: "选择默认组",
    add_custom_group: "添加自定义名称组",
  },
  CONTACT_SHARE: {
    ADD_PHONE_NUMBER: "添加电话号码",
    ADD: "添加",
    SHARE_ACCESS: "选择以下任意一项，与他人共享您想要的访问权限。",
    SELECT_ACCESS: "选择电话簿访问权限",
    DELETE: "删除",
    EDIT: "编辑",
    SEND: "发送",
    PERSONS_WITH_ACCESS: "有权限的人",
    REMOVE_ACCESS: "移除权限",
    RETURN: "返回",
    SAVE_CHANGES: "保存更改",
    SHARE_CONTACT_BOOK: "共享电话簿",
    PHONE_VALIDATION: "请输入正确电话号码",
    SUCCESS_SHARE: "电话簿共享成功。",
    ERROR_SHARE: "共享电话簿时出错！",
    PHONE_DUPLICATE: "号码已添加！",
    CHANGES_SAVED: "更改保存成功。",
    ERROR_SAVING_CHANGES: "保存更改时出错！",
  },
  CONTACT_SEARCH: {
    SEARCH: "搜索",
    ADD_NUMBER: "添加号码",
  },
  CONTACT_PAGINATION: {
    PER_PAGE: "每页",
    FROM: "从",
    TO: "至",
    TOTAL: "总数",
  },
  SUCCESS: {
    DELETED: "删除成功",
    SUCCESS: "成功",
  },
  CONFIRM: {
    DELETE_BULK: "删除未保存的号码？",
  },
  TOOLTIP: {
    CopyPhoneNumbers: "复制您的号码并点击",
    COPY_LINK: "复制链接",
    COPY_NUMBER: "复制号码",
    SEE_PROFILE: "查看个人资料",
  },
  CONTACT_EDIT: {
    EDIT: "编辑",
    DELETE: "删除",
  },
  CONTACT_MENU: {
    SHARE: "共享",
    PRINT: "打印",
    EXCEL_EXPORT: "导出到 Excel",
    DELETE: "删除",
    SUCCESS_DELETE: "删除成功。",
    ERROR_DELETE: "删除联系人时出错！",
  },
  CONTACTS: {
    PREFIX: "前缀",
    NAME: "姓名",
    MIDDLENAME: "中间名",
    LASTNAME: "姓氏",
    POSTFIX: "后缀",
    ALIAS: "别名",
    COMPANY: "公司",
    JOBTITLE: "职位",
    PHONE: "电话",
    PHONE_PLACEHOLDER: "示例：8070 111 13 (989)(989+)(9)(09)",
    ADD_EMAIL: "添加电子邮件",
    EMAIL: "电子邮件",
    ADD_ADDRESS: "添加地址",
    ADDRESS: "地址",
    PROVINCE: "省",
    CITY: "城市",
    POSTALCODE: "邮政编码",
    YEAR_OPTIONAL: "年（可选）",
    MONTH: "月",
    DAY: "日",
    ADD_BIRTHDAY: "添加生日",
    ADD_WEBSITE: "添加网站",
    WEBSITE: "网站",
    ADD_DATE: "添加日期",
    DATE: "日期",
    CUSTOM_FIELD: "自定义字段",
    ADD_CUSTOM_FIELD: "添加自定义字段",
    NOTE: "描述",
    ADD_NOTE: "添加笔记",
    HOME: "家庭",
    WORK: "工作",
    OTHER: "其他",
    PROFILE: "个人资料",
    BLOG: "博客",
    HOMEPAGE: "主页",
    TITLE: "标题",
    BIRTHDAY_ERROR: "请输入正确日期",
    YEAR_ERROR: "4 位数",
    EMAIL_ERROR: "请输入正确电子邮件",
    WEBSITE_ERROR: "请输入正确链接 (website.com)",
    PHONE_ERROR: "请输入正确电话号码",
    ADD_HISTORY: "添加历史",
    HISTORY_LIST: "历史列表",
    EDIT_CONTACT: "编辑联系人",
    SHOW_CONTACT: "显示联系人",
  },
  MONTHS: {
    FARVARDIN: "Farvardin",
    ORDIBEHESHT: "Ordibeheşt",
    KHORDAD: "Khordad",
    TIR: "Tir",
    MORDAD: "Mordad",
    SHAHRIVAR: "Şehrivar",
    MEHR: "Mehr",
    ABAN: "Aban",
    AZAR: "Azar",
    DEY: "Dey",
    BAHMAN: "Bahman",
    ESFAND: "Esfand",
  },

  UPLOAD_EXCEL: {
    DOWNLOAD_SAMPLE: "下载并使用示例 Excel 文件",
    UPLOAD_TITLE: "上传文件",
    DRAG_DROP_TEXT_PART1: "拖放以上传或",
    DRAG_DROP_TEXT_PART2: "点击",
    DRAG_DROP_TEXT_PART3: "此处",
    FILE_INPUT_LABEL: "上传 Excel 文件",
  },
  SUCCESS_MESSAGE: {
    LINK_COPIED: "链接复制成功！",
  },
  ERROR_MESSAGE: {
    COPY_LINK_FAILED: "复制链接时出错。",
  },
  POPUP: {
    TITLE_OR_BUTTON_TEXT: "选择模板/活动",
    BUTTON_EDIT_TEXT: "更改模板/活动",
  },
  BUTTON: {
    REGISTER_NEW_PATTERN: "保存新模板",
    REGISTER_NEW_CAMPAIGN: "保存新活动",
    CREATE_NEW_HISTORY: "创建新历史",
    SAVE_HISTORY: "保存历史",
    SELECT_GROUP: "选择组",
    CREATE_GROUP: "创建组",
    ADD_GROUP: "添加组",
    SAVE: "保存",
    CREATE_GROUP_SINGULAR: "创建组",
    ADD: "添加",
    SEND: "发送",
    EDIT_PERMISSIONS: "编辑",
    GO_BACK: "返回",
    SAVE_CHANGES: "保存更改",
    GUIDE: "指南",
    START: "开始",
    EDIT: "编辑",
    CANCEL: "取消",
    AUTO_REFRESH: "自动刷新",
    AUTO_REFRESH_SETTINGS: "自动刷新设置",
    BACK: "返回",
  },
  TABS: {
    SELECT_PATTERN: "选择模板",
    SELECT_CAMPAIGN: "选择活动",
    LIST: "列表",
    ADD: "添加",
    ADD_CUSTOM_GROUP: "添加自定义名称组",
    SELECT_DEFAULT_GROUP: "选择默认组",
  },
  NO_DATA: {
    NO_PATTERN: "未找到模板，请先保存一个模板。",
  },
  TABLE: {
    ID: "ID",
    TYPE: "类型",
    PATTERN: "模板",
    STATIC: "固定",
    TITLE: "标题",
    TEXT: "文本",
    STATUS: "状态",
    REJECTED: "已拒绝",
    ACCEPTED: "已批准",
    NEXT_BUTTON: "下一页",
    PREVIOUS_BUTTON: "上一页",
    ROWS_PER_PAGE_TEXT: "每页行数",
    NO_DATA_TEXT: "无数据显示",
    PLACEHOLDER_SEARCH: "搜索",
    MORE_INFO_ABOUT_ITEM: "关于 {name} 的更多信息",
  },
  MENU_ITEMS: {
    TEXT_INPUT: "文本",
    SELECT_USER_INFO: "选择用户信息",
  },
  TABLE_CONTROLS: {
    COUNT: "数量",
    SEARCH: "搜索",
  },
  FORM_LABELS: {
    DEFAULT_GROUP_NAME: "默认组名",
    PARENT_CATEGORY: "上级类别",
    HISTORY_TITLE: "历史标题",
    STEP: "步骤",
    LAST_CALL_TIME: "上次通话时间",
    NEGOTIATIONS: "进行的讨论",
    REMINDER_TIME: "提醒时间",
    FOLLOW_UP_ITEMS: "下次通话跟进事项",
    GROUP_NAME: "组名",
    SEARCH: "搜索",
    TITLE: "标题",
    SEARCH_IN_TITLE: "在标题中搜索",
    FROM: "从",
    TO: "至",
    BIRTHDAY_FROM: "生日从",
    BIRTHDAY_TO: "至",
    COUNT: "数量",
    ADD_PHONE_NUMBER: "添加电话号码",
  },
  TOAST: {
    Success: "操作成功完成",
    Error: "发生错误",
    Warning: "警告：请检查输入",
    AUTO_REFRESH_STARTED: "自动刷新已开始。",
    DEFAULT_GROUP_SUCCESS: "默认组添加成功。",
    DEFAULT_GROUP_ERROR: "添加默认组时出错！",
    ADD_HISTORY_ERROR: "添加客户历史时出错！",
    DUPLICATE_NAME: "名称已存在",
    TAG_ADDED_SUCCESS: "标签添加成功。",
    TAG_DELETED_SUCCESS: "标签删除成功",
    TAG_EDITED_SUCCESS: "标签编辑成功",
    GROUPS_ADDED_SUCCESS: "选定组已成功添加。",
    ADD_GROUP_ERROR: "添加默认组时出错！",
    PHONE_COPIED_SUCCESS: "电话号码已复制。",
    SUCCESSFULLY_DELETED: "删除成功",
    ERROR_DELETING_CONTACT_FROM_PHONEBOOK: "从电话簿删除联系人时出错！",
    SHARE_SUCCESS: "电话簿共享成功。",
    SHARE_ERROR: "共享电话簿时出错！",
    NUMBER_ALREADY_ADDED: "号码已添加！",
    CHANGES_SAVED_SUCCESS: "更改保存成功。",
    CHANGES_SAVE_ERROR: "保存更改时出错！",
  },
  HEADERS: {
    GRADUAL_SEND: "分阶段发送",
    GRADUAL_SEND_HINT: "（适用于超过 500 个号码）",
  },
  CHECKBOX_LABELS: {
    GRADUAL_SENDING: "分阶段发送",
    DELETE: "删除",
    EDIT: "编辑",
    ADD: "添加",
  },
  MESSAGES: {
    SENDING_INTERVAL_QUESTION: "每 {time} 发送一次消息吗？",
  },
  LABELS: {
    TIME_INTERVAL: "时间间隔",
    MESSAGE_COUNT: "消息数量",
  },
  TIME_TYPES: {
    MINUTE: "分钟",
    HOUR: "小时",
    DAY: "天",
    WEEK: "周",
    SECOND: "秒",
  },
  HINTS: {
    MESSAGE_COUNT_PER_PART: "输入每批发送的消息数量。",
  },
  RULES: {
    MESSAGE_COUNT_MIN_LIMIT: "每批消息数量不能少于 500！",
  },
  TABLE_HEADERS: {
    ROW: "序号",
    TITLE: "标题",
    STEP: "步骤",
    REMINDER_TIME: "提醒时间",
    LAST_CALL_TIME: "上次通话时间",
    RECORDER: "记录者",
    MANAGEMENT: "管理",
    ID: "ID",
    GROUP_NAME: "组名",
    PARENT: "上级",
    CREATED_AT: "创建时间",
    IMAGE: "照片",
    FULL_NAME: "姓名",
    EMAIL: "电子邮件",
    PHONE_NUMBER: "电话号码",
    JOB_COMPANY: "职位和公司",
    CREATION_TIME: "创建时间",
    PHONEBOOK: "电话簿",
    ACTIONS: "操作",
    USER: "用户",
  },
  PROPS: {
    SOURCE_NUMBER_LABEL: "源号码",
  },
  MODAL: {
    INFO_TITLE: "注意。",
    INFO_MESSAGE_NEWS_NUMBER: '"{number}" 源号码发送时，最小数量必须为 1000。',
    CONFIRM_DELETE_GROUP: "确认删除组？",
  },
  SPECIAL_NUMBERS: {
    NEWS_SEND: "新闻发送",
  },
  POPUP_TITLES: {
    SYSTEM_GUIDE: "系统指南",
    ERROR: "错误",
    WARNING: "警告",
    SUCCESS: "成功",
    CONFIRM: "确认",
    SELECT_GROUP: "选择组",
    CREATE_NEW_GROUP: "创建新组",
    SELECT_GROUP_SUBGROUP: "选择组和子组",
    CREATE_DEFAULT_GROUP: "创建默认组",
    DELETE_CONTACT_FROM_GROUP: "从组中删除联系人",
    DELETE_CONTACT: "删除联系人",
    SHARE_PHONEBOOK: "共享电话簿",
    SYSTEM_GUIDE: "广告终端系统指南",
  },
  CARD_TITLES: {
    ENTER_GROUP_NAME: "输入您想要的名称",
    SELECT_PERMISSIONS: "为 {name} 电话簿选择访问权限：",
    PEOPLE_WITH_ACCESS: "有权限的人",
  },
  LOADING_MESSAGES: {
    FETCHING_CATEGORIES: "加载类别中...",
  },
  RADIO_LABELS: {
    GROUP_WITH_SUBGROUPS: "添加组及子组",
    SELECTED_GROUP_ONLY: "仅添加选定组",
    DELETE_FROM_THIS_GROUP_ONLY: "仅从此组删除联系人",
    DELETE_FROM_ALL_GROUPS: "从所有组删除联系人",
  },
  FILTER_LABELS: {
    ADDRESS: "地址",
    EMAIL: "电子邮件",
    WEBSITE: "网站",
    CUSTOM_FIELD: "自定义字段",
    DATE: "日期",
  },
  CARD_SUBTITLES: {
    SHARE_INSTRUCTION: "选择以下任意一项，与他人共享您想要的访问权限。",
  },
  VALIDATION: {
    INVALID_PHONE_NUMBER: "请输入正确电话号码",
  },
  LIST_ITEM_TITLES: {
    DELETE: "删除",
    EDIT: "编辑",
    ADD: "添加",
    REMOVE_ACCESS: "移除权限",
  },
  CAMPAIGN: {
    CAMPAIGN_NAME: "活动名称",
    TEXT: "文本",
    MESSAGE: "消息",
    FOR: "用于",
    SELECT_CAMPAIGN: "选择活动",
    CLICK_ROW: "点击您想要的行。",
    NEW: "新建",
    SUBMIT_CAMPAIGN: "保存活动",
    TIME: "时间",
    MESSAGE_COUNT: "消息数量",
    PAGE_COUNT: "总消息（页）",
    PAGE: "页",
    CANCEL_TEXT: "取消11",
    TRACKABLE_LINK: "可追踪链接",
    WARNING_TEXT: "请修正选定活动的文本！",
    WARNING_TITLE: "请修正选定活动的标题！",
    WARNING_GAP: "请修正选定活动的时间间隔！",
    WARNING_OPERATOR: "请修正选定活动的运营商！",
    MAX_ITEMS_ERROR: "最多可添加 10 项。",
  },
  ADS: {
    LIVE_SMS: "实时短信发送",
    BUY_JOB_DB: "购买职业数据库",
    SMART_LADDER: "Divar 广告智能阶梯",
    JOB_SMS: "向职业发送短信",
    WEB_DESIGN: "网站设计订单",
    SEO: "网站 SEO 订单",
    MAP_SMS: "从地图发送短信",
    GRADUAL_LADDER: "Divar 广告分阶段阶梯",
    SEO_ALT: "网站 SEO 订单",
    SITE_SUPPORT: "网站管理和支持",
    CITY_SMS: "城市和省份短信发送",
    AUTO_CHAT: "Divar 自动聊天",
  },
  TUTORIALS: {
    WHATSAPP_SUPPORT: "WhatsApp 联系",
    TICKET_SUPPORT: "注册票据",
  },
  INCREASE: {
    PAN: "卡号",
    CVV2: "CVV2",
    MONTH: "月",
    YEAR: "年",
    PIN2: "第二密码",
    GET_OTP: "获取第二密码",
    PAY: "支付",
    INVALID_PAN: "卡号错误",
    INVALID_CVV2: "CVV2 错误",
  },
  WALLET: {
    CustomCharge: "钱包充值",
    withdrawTitle: "从钱包提现",
    transactionListTooltip: "您的交易列表",
    reloadTooltip: "刷新",
    withdrawTooltip: "从钱包提现",
    AmountLabel: "金额 ",
    SelectAmount: "选择金额",
    Amount: "金额",
    Currency: "里亚尔",
    GateWay: "支付网关",
    noGateWay: "未找到网关",
    Pay: "支付",
    PriceNotInRange: "金额必须在 {min} 和 {max} 之间。",
    ErrorOnRedirectToGateWay: "跳转到支付网关时出错",
    ErrorGeneral: "错误",
    MinAmountError: "输入金额小于最小值。",
    MinBazarAmountError: "金额不能少于 10,000 托曼！",
    BazarSuccessInfo: "支付成功后，您的钱包将在 1-3 分钟内充值。",
    withdrawableBalance: "可提现余额",
    withdrawFee: "提现手续费：50,000 里亚尔！",
    selectAccount: "选择账户",
    addAccount: "添加账户",
    submitWithdraw: "确认提现",
    accountRequiredInfo: "所有信息必填。",
    ownerName: "账户持有人姓名",
    ownerLastName: "姓氏",
    bankName: "银行名称",
    accountNumber: "账户号码",
    cardNumber: "卡号",
    sheba: "Sheba 号码",
    onlyPersian: "仅允许波斯字母！",
    cardNumberLength: "卡号必须为 16 位！",
    shebaLength: "Sheba 号码必须为 24 位！",
  },
  USER_PICKER: {
    SELECT_USER: "选择用户",
    SELECT_USERS: "选择用户",
    SEARCH: "搜索",
    PERSON: "自然人",
    COMPANY: "法人",
    ID: "ID",
    NAME: "姓名",
    LASTNAME: "姓氏",
    USERNAME: "用户名",
    PHONE: "电话",
    TYPE: "用户类型",
  },
  NEWS: {
    TITLE: "SMS Land 新闻",
    VIEW_BUTTON: "查看",
    NO_NEWS: "没有新新闻。",
    FETCH_ERROR: "获取新闻时出错！",
  },
  MENUS: {
    CONTACT_LIST: "联系人列表",
    FINDPREFIX: "查找前缀",
    // 系统
    TICKET_REGISTRATION: "注册票据",
    AD_TERMINAL_SYSTEM: "大型广告终端系统",
    WALLET_TRANSACTIONS: "钱包交易",
    DYNAMIC_QR_SYSTEM: "动态 QR 创建系统",
    DIVAR_AD_SYSTEM: "Divar 广告发布和管理系统",
    GRAPHIC_DESIGN_SYSTEM: "图形设计和印刷订单系统",
    DIGITAL_MARKETING_SYSTEM: "数字营销管理系统",
    BULK_SMS_SYSTEM: "批量短信发送系统",
    BUSINESS_INFO_SYSTEM: "国家职业信息库系统",
    AD_MANAGEMENT_SYSTEM: "广告管理系统",
    GRAPHIC_VIDEO_SERVICES: "图形设计和视频服务系统",
    // QR 工具
    QR_TOOL: "QR 工具",
    CREATE_DYNAMIC_QR: "创建动态 QR",
    QR_MANAGEMENT: "QR 管理",
    QR_MONITORING: "QR 监控",
    MY_QR_LIST: "我的 QR 列表",
    PHYSICAL_NFC_ORDERS: "实体卡和 NFC 订单",
    BULK_QR_GENERATION: "批量 QR 创建",
    IMAGE_CREATION_TOKEN: "图像创建令牌",
    QR_SMS: "QR 短信",
    QR_LINK: "QR 链接",
    QR_TEXT: "QR 文本",
    QR_LOCATION: "QR 位置",
    QR_EMAIL: "QR 电子邮件",
    QR_CALL: "QR 通话",
    QR_WIFI: "QR Wi-Fi",
    VISIT_STATISTICS: "访问统计",
    // 广告管理
    AD_MONITORING: "广告监控",
    DIVAR_NEWS: "Divar 新闻",
    REAL_ESTATE_AD_SUBMISSION: "房地产面板广告发布",
    AUTO_AD_RENEWAL: "广告自动续订",
    GRADUAL_AD_SUBMISSION: "分阶段广告发布",
    SMART_AD_SUBMISSION: "智能广告发布",
    DEFAULT_AD_REGISTRATION: "默认广告注册",
    AD_ANALYZER: "广告访问分析器",
    ADD_AD_PHOTO: "添加广告照片",
    SMART_LADDER: "智能阶梯",
    GRADUAL_LADDER: "分阶段阶梯",
    ADS_LIST: "广告列表",
    AD_REPORTS: "广告报告",
    SCHEDULED_AD_SUBMISSION: "定时广告发布",
    SCHEDULED_AD_LIST: "定时广告列表",
    PERSONAL_AD_SUBMISSION: "个人广告发布",
    TARGET_TOOLS: "目标工具",
    SMART_LIST: "智能/分阶段列表",
    // SMS
    SEND_TO_CUSTOMER_CLUB: "发送到客户俱乐部",
    BULK_SMS: "批量短信",
    LIVE_SMS: "实时短信（旧版）",
    SEND_TO_BUSINESSES: "发送到国家职业",
    SMS_BY_MAP: "从地图发送短信",
    CITY_PROVINCE_SMS: "城市和省份发送",
    RECEIVED_SMS_LIST: "接收短信列表",
    SMS_TEXT_CONSULTANT: "短信文本顾问监控",
    DEFAULT_TEXT_CONSULTATION: "默认文本 + 咨询",
    ADMIN_SMS_SUBMISSIONS: "管理员发送",
    PENDING_SMS: "待批准短信",
    ADMIN_RECEIVED_REPORT: "管理员接收报告",
    PATTERN: "模板/Pattern",
    SMS_REPORTS: "发送报告",
    DEDICATED_LINE_REQUESTS: "专用线路请求",
    PHONEBOOK: "电话簿",
    SMS_TARIFFS: "短信资费",
    LINE_CATEGORIES: "线路类别",
    TARIFF_COEFFICIENTS: "发送资费系数",
    SEND_ADMIN_SMS: "管理员短信发送",
    // 号码和联系人
    ADD_NEW_NUMBER: "添加新号码",
    NUMBERS: "号码",
    USER_NUMBERS: "用户号码",
    REGISTER_USER_NUMBER: "为用户注册号码",
    NUMBER_LIST: "我的号码列表",
    CREATE_NUMBER_TARIFF: "创建号码资费",
    NUMBER_TARIFF_LIST: "号码资费列表",
    OTHER_TARIFF_LIST: "其他资费列表",
    // 财务管理
    WALLET: "新钱包",
    TRANSFER_REQUESTS: "提现请求",
    DIVAR_PAYMENTS: "Divar 支付",
    AUTO_PAYMENT: "自动支付",
    PAYMENTS: "支付",
    PAYMENT_GATEWAY: "支付网关",
    BUY_CHARGE: "购买充值",
    // 客户和用户管理
    CUSTOMERS: "客户",
    CRM_CUSTOMERS: "CRM 客户",
    CONTACT_LIST: "联系助手（联系感谢）",
    USERS: "用户列表",
    USER_REQUESTS: "用户请求",
    PROFILE: "个人资料",
    USER_HISTORY_NOTIFICATIONS: "用户历史通知",
    // 设计和内容
    WEBSITE_DESIGN_ORDER: "网站设计订单",
    SEO_ORDER: "网站 SEO 订单",
    BUY_INFO_DATABASE: "购买信息库",
    BUY_MOBILE_DATABASE: "购买手机号码库",
    PURCHASED_ARCHIVES: "已购档案",
    FAVORITE_ARCHIVES: "收藏档案",
    UPLOAD_CENTER: "上传中心",
    CONTENT: "内容",
    // 管理和设置
    MONITORING: "监控",
    MANAGEMENT: "管理",
    SETTINGS: "设置",
    CATEGORIES: "类别",
    DOMAINS: "域名",
    REMINDERS: "提醒",
    AUTOMATIC_CREATION: "自动创建",
    PERMISSIONS: "权限",
    ROLES: "角色",
    MENUS: "菜单",
    CORE_MANAGEMENT: "核心管理",
    WORK_REPORTS: "工作报告管理",
    WORK_REPORT_CREATE: "工作报告",
    DEPARTMENTS: "部门",
    DISCOUNTS: "折扣",
    NOTIFICATIONS: "通知",
    ADMIN_NOTIFICATIONS: "管理员通知",
    TICKET_MANAGEMENT: "票据管理",
    USER_GUIDE: "用户指南",
    CAMPAIGN: "活动",
    MESSAGE_CATEGORIES: "消息类别",
    REGISTERED_INFO_LIST: "注册信息列表",
    TARIFFS: "资费",
    INFORMATION_REGISTRATION: "信息注册",
    UNCREATED_CARDS: "未创建卡片",
    MODELS_LIST: "模型列表",
    CREATE_DEFAULT_PRODUCT: "创建默认产品",
    EXCEL_FILES: "Excel 文件",
    AUTO_CHATS: "智能聊天",
    AUTO_CHAT: "自动聊天",
    // 其他
    MY_FILES: "我的文件",
    CONSULTANTS: "顾问",
    ADD_DIVAR_NEWS: "添加 Divar 新闻",
    BUY_PANEL: "购买面板",
    PANELS: "面板",
    CALL_MONITORING: "通话监控",
    INFO_REVIEW: "信息审查",
    MESSAGES: "消息",
    PERSONNEL: "员工",
    //qr
    QR_TOOL: "QR 工具",
    CREATE_DYNAMIC_QR: "创建动态 QR",
    QR_MANAGEMENT: "QR 管理",
    QR_MONITORING: "QR 监控",
    MY_QR_LIST: "我的 QR 列表",
    PHYSICAL_NFC_ORDERS: "实体卡和 NFC 订单",
    BULK_QR_GENERATION: "批量 QR 创建",
    IMAGE_CREATION_TOKEN: "图像创建令牌",
    CATEGORIES: "类别",
    CREATE_DEFAULT_PRODUCT: "创建默认产品",
    DOMAINS: "域名",
    REMINDERS: "提醒",
    AUTOMATIC_CREATION: "自动创建",
    SEND_ADMIN_SMS: "管理员短信发送",
    UNCREATED_CARDS: "未创建卡片",
    MODELS_LIST: "模型列表",
    UPLOAD_CENTER: "上传中心",
    INFORMATION_REGISTRATION: "信息注册",
    TARIFFS: "资费",
    REGISTERED_INFO_LIST: "注册信息列表",
    //code
    personel: "员工",
    "workReports/create": "工作报告",
    "admin/user-guide": "用户指南",
    phonebook: "客户俱乐部",
    contactlist: "联系助手（联系感谢）",
    "contact/list": "联系助手（联系感谢）",
    "admin/transferRequests": "提现请求",
    "admin/wallet": "新钱包",
    "admin/cdr": "通话监控",
    "admin/campaign": "活动",
    "admin/message-categories": "消息类别",
    "admin/customers": "CRM 客户",
    "admin/notifications": "管理员通知",
    "admin/user-history/notifications": "用户历史通知",
    "admin/messages": "消息",
    profile: "个人资料",
    "admin/workReports": "工作报告管理",
    panel: "购买面板",
    adminDiscounts: "折扣",
    departments: "部门",
    adminTickets: "票据管理",
    "admin/configs": "设置",
    notifications: "通知",
    "user/confirmed": "用户请求",
    users: "用户列表",
    payments: "支付网关",
    permission: "权限",
    panels: "面板",
    category: "菜单",
    content: "内容",
    role: "角色",
    "core/admin": "核心管理",
    //robot
    numberList: "我的号码列表",
    registerAd: "注册广告",
    proPanelSendAd: "专业面板广告发布",
    buyCharge: "购买充值",
    scheduledAdSend: "定时广告发布",
    smartGradual: "智能/分阶段",
    createNumberTariff: "创建号码资费",
    numberTariffList: "号码资费列表",
    otherTariffList: "其他资费列表",
    userNumbers: "用户号码",
    numbers: "号码",
    management: "管理",
    settings: "设置",
    registerUserNumber: "为用户注册号码",
    divarPayments: "Divar 支付",
    autoPayment: "自动支付",
    adAnalyzer: "广告访问分析器",
    infoReview: "信息审查",
    rb_payments: "支付",
    autoChat: "自动聊天",
    ads: "广告",
    monitoring: "监控",
    smartLadder: "智能阶梯",
    gradualLadder: "分阶段阶梯",
    excelFiles: "Excel 文件",
    autoChats: "智能聊天",
    addAdPhoto: "添加广告照片",
    targetTools: "目标工具",
    smartList: "智能/分阶段列表",
    scheduledAdList: "定时广告列表",
    adsList: "广告列表",
    adReports: "广告报告",
    personalAdSend: "个人广告发布",
  },
  AUTO_REFRESH_POPUP: {
    TITLE: "输入您想要的时间：",
    SUBTITLE: "设置时间后，此页面将按选定时间自动刷新。",
    TIME_LABEL: "时间",
  },
  MODAL: {
    OK_TITLE: "确认",
  },

  ROUTE: {
    TITLES: {
      "QR_NAME_EDIT_GIFT": "编辑礼物二维码",
      "QR_GIFT": "礼物二维码",
      QR_CARD_VISIT_PRO:"编辑 Pro 链接 QR",
      "QR_NAME_EDIT_PRO": "编辑 Pro 链接 QR 码",
      "QR_LINK_EDIT_PRO": "编辑SEO点击助手二维码",
      "QR_LINK_PRO": "SEO点击助手二维码",
        DIGI: "Digikala 定价监控",
      QR_PDF: "PDF图库",
      QR_NAME_EDIT_PDF: "编辑PDF图库",
      QR_MULTICART: "多重QR卡",
      QR_MULTICART_EDIT: "编辑多重QR卡",
      QR_PRODUCTPRO: "产品介绍 (专业版)",
      QR_NAME_PRODUCTPRO: "编辑产品介绍 (专业版)",
      QR_NAME_EDIT_CATALOG: "编辑目录",
      QR_LUCK_WHEEL_Edit: "编辑幸运转盘",
      QR_LUCK_WHEEL: "创建运气转盘二维码",
      DASHBOARD: "仪表板",
      ADMIN_QR_DOMAINS: "域名监控",
      ADMIN_TOGETHER_TOKEN: "令牌监控",
      ADMIN_QR_SMS: "短信发送",
      MENU_PROFILE_INFO: "用户信息",
      MENU_PROFILE_SETTING: "个人资料设置",
      MENU_PROFILE_ORDERS: "订单",
      MENU_PROFILE_ADDRESSES: "地址",
      QR_MONITORING: "QR 监控",
      QR_LIST: "我的 QR 列表",
      QR_NAME_LIST: "参与管理",
      QR_GENERATE_MULTIPLE: "批量 QR 创建",
      QR_CARD_VISIT: "创建名片",
      HELP_INFO: "按钮测试",
      QR_MENU: "商店菜单",
      QR_APPOINTMENT: "预约",
      QR_INSURANCE: "创建在线保险",
      QR_BPAGE: "创建业务页面",
      QR_CPAGE: "创建商业/行政综合体网站",
      QR_BSHOP: "在线商店",
      QR_NAME_EDIT_BSHOP: "编辑在线商店",
      QR_LINK_EDIT: "编辑链接",
      QR_NAME_DESIGN: "编辑设计",
      QR_NAME_SETTING: "编辑设置",
      QR_NAME_EDIT: "编辑名片",
      QR_NAME_EDIT_BPAGE: "编辑业务页面",
      QR_EDIT_CPAGE: "编辑综合体网站",
      QR_NAME_INSURANCE: "编辑在线保险",
      QR_NAME_EDIT_MENU: "编辑菜单",
      QR_NAME_EDIT_APPLICATION: "应用展示",
      QR_NAME_EDIT_APPOINTMENT: "编辑预约",
      QR_NAME_EDIT_PHOTO: "编辑照片图库",
      QR_NAME_EDIT_VIDEO: "编辑视频图库",
      QR_NAME_EDIT_VOICE: "编辑语音图库",
      QR_NAME_EDIT_FEEDBACK: "编辑反馈图库",
      QR_NAME_CONSULTATION_QR_EDIT: "编辑请求表单",
      QR_NAME_EDIT_VOICE_PRO: "编辑语音图库（专业版）",
      QR_NAME_EDIT_SOCIAL: "编辑社交媒体",
      QR_NAME_STATISTICS: "QR 码统计",
      QR_CATE: "选择类别",
      QR_SHARE: "共享",
      QR_BUSINESS_SHOP: "业务/商店",
      QR_CO_ORGAN: "公司/组织",
      QR_CONTACT: "客户联系",
      QR_NOTICES: "通知",
      QR_OTHERS: "其他",
      QR_STATICS: "静态 QR",
      QR_DYNAMICS: "动态 QR",
      QR_D_BUSINESS: "动态业务 QR",
      QR_D_ORGANS: "动态组织 QR",
      QR_D_GOVERNMENT: "动态政府 QR",
      QR_VIDEO: "视频图库",
      QR_APPLICATION: "应用展示",
      QR_VOICE: "语音图库",
      QR_VOICE_PRO: "语音图库（专业版）",
      QR_CONSULTATION_QR: "请求表单",
      QR_FEEDBACK: "反馈图库",
      QR_PHOTO: "照片图库",
      QR_CATALOG: "目录 / 宣传册",
      QR_LOCATION: "创建位置 QR",
      QR_SOCIAL_MEDIA: "创建社交媒体 QR",
      QR_LINK: "创建链接",
      QR_TEXT: "创建文本",
      QR_MAIL: "创建电子邮件",
      QR_CALL: "通话",
      QR_SMS: "短信",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "网站",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "Wi-Fi",
      QR_BUSINESS: "业务页面",
      QR_DISCOUNT: "折扣页面",
      QR_PRODUCT_SHOP: "产品介绍",
      QR_PRODUCT_LABEL: "产品标签",
      QR_GOLD_LABEL: "黄金标签",
      QR_PRODUCT_TEMPLATE: "产品",
      ADMIN_CATEGORY: "类别",
      QR_NFC_ORDERS: "待批准 NFC 卡",
      QR_NAME_PRODUCT: "编辑产品介绍",
      QR_NAME_LABELPRODUCT: "编辑产品标签",
      QR_NAME_GOLDPRODUCT: "编辑黄金标签",
      QR_COINS: "加密货币",
      QR_SHOP: "商店管理",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "上传中心",
      PRICING: "QR 资费",
      QR_CREATE_MODELS: "创建名片模型",
      QR_CREATE_BUSINESS_MODELS: "创建业务页面模型",
      QR_CREATE_PRODUCT_MODEL: "创建产品卡模型",
      QR_CREATE_MENU_MODELS: "创建商店菜单模型",
      QR_CREATE_SHOP_MODEL: "创建在线商店模型",
      MODELS_LIST: "QR 模型类型",
      MODELS_LIST_EDIT: "编辑模型",
      MODELS_LIST_MENU_EDIT: "编辑菜单模型",
      MODELS_LIST_BMODEL_EDIT: "编辑在线商店模型",
      NFC: "NFC 卡",
      SUBMIT_FORM: "注册博主",
      REQUEST_LIST: "博主列表",
      PURE_DATA: "未创建名片列表",
      AUTO_CREATE: "自动 QR 创建",
      QR_CREATE: "创建 QR",
      HISTORY_REMINDER: "提醒监控",
      BOOK: "提醒监控"
    },
  },
  qr_management: "QR 管理",
  router: {
    dashboard: "仪表板",
    contacts: "客户俱乐部",
    editContact: "编辑客户",
    createContact: "创建客户",
    customers: "客户列表",
    contactList: "联系助手",
    messages: "消息",
    messageCategories: "消息类别",
    oldTransactions: "旧交易",
    yourTransactions: "您的交易",
    buyPanel: "购买面板",
    permissions: "权限",
    createPermission: "创建权限",
    invitations: "我的邀请列表",
    editUser: "编辑用户",
    userInformation: "查看用户信息",
    walletEdit: "编辑用户钱包信息",
    userHistory: "用户历史",
    userNotificationsHistory: "用户通知历史",
    notifications: "通知",
    createNotification: "创建通知",
    editNotification: "编辑通知",
    adminNotifications: "管理员通知",
    yourNotifications: "您的通知",
    adminNotificationsList: "管理员通知列表",
    tickets: "票据",
    createTicket: "注册新票据",
    editTicket: "编辑票据",
    departments: "部门",
    createDepartment: "新建部门",
    editDepartment: "编辑部门",
    adminTickets: "票据管理",
    discounts: "折扣",
    createDiscount: "创建折扣",
    editDiscount: "编辑折扣",
    workReports: "工作报告",
    createWorkReport: "创建工作报告",
    callMonitoring: "通话监控",
    adminWorkReports: "工作报告管理",
    editWorkReport: "查看并编辑工作报告",
    packProperties: "套餐属性",
    createPackProperty: "创建套餐属性",
    editPackProperty: "编辑套餐属性",
    panels: "面板",
    createPanel: "创建面板",
    editPanel: "编辑面板",
    transferRequests: "提现请求",
    editTransferRequest: "编辑提现请求",
    tariffs: "资费",
    createTariff: "创建资费",
    editTariff: "编辑资费",
    requests: "请求",
    viewUser: "查看用户",
    manageTransactions: "交易管理",
    viewTransaction: "查看交易",
    manageConfigs: "设置管理",
    rbLandConfigs: "Robot Land 设置管理",
    editConfig: "编辑设置",
    manageUsers: "用户管理",
    categories: "类别",
    createCategory: "添加类别",
    editCategory: "编辑类别",
    content: "内容",
    createContent: "添加内容",
    editContent: "编辑内容",
    addUserGuide: "添加用户指南",
    editUserGuide: "编辑用户指南",
    roles: "角色",
    editRole: "编辑角色",
    createRole: "添加角色",
    permissionTitle: "权限",
    paymentGateways: "支付网关",
    editPaymentGateway: "编辑支付网关",
    campaigns: "活动",
    createCampaign: "创建活动",
    editCampaign: "编辑活动信息",
    adminCustomers: "客户",
    createCustomer: "创建客户",
    editCustomerInfo: "编辑客户信息",
    referrerCustomers: "推荐客户",
    customerHistory: "客户历史",
    userProfile: "用户个人资料",
    editProfile: "编辑个人资料",
    inviteFriends: "邀请朋友",
    personalInfo: "个人信息",
    editPersonalInfo: "编辑信息",
    changePassword: "更改密码",
    newWallet: "新钱包",
  },
  ticket: {
    text: "注册票据",
  },
};
